import contentfulGql from 'js/lib/contentfulGql';

export const entWebsiteBlockAssemblyIdTypeOnlyFragment = contentfulGql`#graphql
  fragment EntWebsiteBlockAssemblyIdTypeOnly on EntWebsiteBlockAssembly {
    anchorId

    sys {
      id
    }

    reference {
      __typename
      ...on EntWebsiteTwoColumns {
        leftColumn {
          __typename
        }
        rightColumn {
          __typename
        }
      }
      ...on EntWebsiteAcademyModule {
        slug
      }
      ...on EntWebsiteBenefitList {
        slug
      }
      ...on EntWebsiteCaseStudy {
        slug
      }
      ...on EntWebsiteComparePlans {
        slug
      }
      ...on EntWebsiteContactSales {
        slug
      }
      ...on EntWebsiteContent {
        slug
      }
      ...on EntWebsiteCtaBlock {
        slug
      }
      ...on EntWebsiteFaq {
        slug
      }
      ...on EntWebsiteHow {
        slug
      }
      ...on EntWebsiteLeaderList {
        slug
      }
      ...on EntWebsiteMarketoModule {
        slug
      }
      ...on EntWebsitePartnerList {
        slug
      }
      ...on EntWebsiteSkillsets {
        slug
      }
      ...on EntWebsiteTestimonial {
        slug
      }
      ...on EntWebsiteTestimonialCarousel {
        slug
      }
      ...on EntWebsiteValuePropModule {
        slug
      }
      ...on EntWebsiteWhy {
        slug
      }
      ...on EntWebsiteCourseSearchWidget {
        slug
      }
      ...on EntWebsiteCerosWidget {
        slug
      }
      ...on EntWebsitePdfViewer {
        slug
      }
      ...on EntWebsiteResource {
        slug
      }
      ...on EntWebsiteTabs {
        slug
      }
      ...on EntWebsiteFeaturedContent {
        slug
      }
      ...on EntWebsiteUpcomingEvents {
        slug
      }
      ...on EntWebsiteResourceHubCollectionWithSearch {
        slug
      }
      ...on EntWebsiteHow {
        slug
      }
      ...on EntWebsiteTwoColumns {
        slug
      }
      ...on EntWebsiteInsights {
        slug
      }
      ...on EnterpriseArticle {
        slug
        sys {
          firstPublishedAt
          publishedAt
        }
      }
        
      ...on EntWebsiteNative {
        slug
      }
    }
  }
`;

export const entWebsiteBlockAssemblyFragment = contentfulGql`#graphql
  fragment EntWebsiteBlockAssembly on EntWebsiteBlockAssembly {
    sys {
      id
    }
    anchorId
    slug
    ctaVariant
    entryTitle
    eyebrow
    eyebrowColor
    visibility
    layout
    layoutOptions
    theme
    mobileBreakpoint
    supportedLocales
  }
`;
